import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ePageBaseStatus } from "../models/ePageBaseStatus";
import { IThongKeSiSoItem } from "../models/response/thong-ke/IThongKeSiSoItem";
import { actions } from "../state/actions/actionsWrapper";
import { RootState } from "../state/reducers";
import { useCommonSelectedHook } from "./useCommonSelectedHook";

const mainAction = actions.thongKe.thongKeSiSo;

let lastFilterKeyGlobal = '';

export const useThongKeSiSo = () => {
    const { status, data, filter, expandedIds, trangThai } = useSelector((x: RootState) => x.thongKe.thongKeSiSo)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const dispatch = useDispatch();
    
    useEffect(() => {
        const currentFilterKey = `${nam_hoc || ''}_${dm_coso_id || 0}`;
        const stateFilterKey = `${filter.nam_hoc || ''}_${filter.dm_coso_id || 0}`;
        
        if (
            nam_hoc &&
            dm_coso_id &&
            currentFilterKey !== stateFilterKey &&
            currentFilterKey !== lastFilterKeyGlobal
        ) {
            lastFilterKeyGlobal = currentFilterKey;
            const payload = {
                nam_hoc,
                dm_coso_id
            };
            dispatch(mainAction.CHANGE_FILTER(payload));
            dispatch(mainAction.LOAD_START(payload));
            dispatch(mainAction.LOAD_TRANG_THAI_START(payload));
        }
    }, [nam_hoc, dm_coso_id, filter.nam_hoc, filter.dm_coso_id, dispatch])
    
    useEffect(() => {
        if (filter.nam_hoc && filter.dm_coso_id) {
            if (status === ePageBaseStatus.is_not_initialization || status === ePageBaseStatus.is_need_reload) {
                dispatch(mainAction.LOAD_START(filter));
                dispatch(mainAction.LOAD_TRANG_THAI_START(filter));
            }
        }
    }, [filter, status, dispatch])
    
    const dataStructed = useMemo(() => {
        let _truongMap = new Map<string, IThongKeSiSoItem>();
        data.forEach(row => {
            const trangThaisLop = trangThai.filter(x => x.dm_lop_id === row.dm_lop_id)
            let trangThaiSumLop = new Map<number, number>();
            trangThaisLop.forEach(x => {
                trangThaiSumLop.set(x.dm_trangthaihocsinh_id, x.si_so)
            })
            const truongId = `TRUONG_${row.dm_truong_id}`;
            const khoiId = `KHOI_${row.dm_khoi_id}`;
            const heId = `HE_${row.dm_he_id}`;
            const lopId = `LOP_${row.dm_lop_id}`;
            if (!_truongMap.has(`TRUONG_${row.dm_truong_id}`)) {
                _truongMap.set(truongId, {
                    id: truongId,
                    items: new Map<string, IThongKeSiSoItem>(),
                    name: row.ten_truong,
                    si_so: 0,
                    type: "truong",
                    trangThaiSum: new Map<number, number>()
                })
            }
            let truongItem = _truongMap.get(truongId);
            if (!truongItem?.items.has(khoiId)) {

                truongItem?.items.set(khoiId, {
                    id: khoiId,
                    items: new Map<string, IThongKeSiSoItem>(),
                    name: row.ten_khoi,
                    si_so: 0,
                    type: "khoi",
                    trangThaiSum: new Map<number, number>()
                })
            }
            let khoiItem = truongItem?.items.get(khoiId);
            if (!khoiItem?.items.has(heId)) {

                khoiItem?.items.set(heId, {
                    id: heId,
                    items: new Map<string, IThongKeSiSoItem>(),
                    name: row.ten_he,
                    si_so: 0,
                    type: "he",
                    trangThaiSum: new Map<number, number>()
                })
            }
            let heItem = khoiItem?.items.get(heId);
            if (!heItem?.items.has(lopId)) {

                heItem?.items.set(lopId, {
                    id: lopId,
                    items: new Map<string, IThongKeSiSoItem>(),
                    name: row.ten_lop,
                    si_so: row.si_so,
                    type: "lop",
                    trangThaiSum: trangThaiSumLop
                })
            }
            if (truongItem) {
                truongItem.si_so += row.si_so;
                let khoiItem = truongItem.items.get(khoiId);
                if (khoiItem) {
                    khoiItem.si_so += row.si_so;
                    let heItem = khoiItem.items.get(heId);
                    if (heItem) {
                        heItem.si_so += row.si_so;
                        trangThaiSumLop.forEach((value, key) => {
                            if (heItem) heItem.trangThaiSum.set(key, (heItem?.trangThaiSum.get(key) ?? 0) + value)
                            if (khoiItem) khoiItem.trangThaiSum.set(key, (khoiItem?.trangThaiSum.get(key) ?? 0) + value)
                            if (truongItem) truongItem.trangThaiSum.set(key, (truongItem?.trangThaiSum.get(key) ?? 0) + value)
                        })
                    }
                }
            }

        })
        return _truongMap;
    }, [data, trangThai])
    const dmTrangThais = useMemo(() => {
        let result = new Map<number, any>();
        trangThai.forEach(data => {
            if (data.dm_trangthaihocsinh_id > 0) {
                if (!result.has(data.dm_trangthaihocsinh_id)) {
                    result.set(data.dm_trangthaihocsinh_id, {
                        id: data.dm_trangthaihocsinh_id,
                        dm_trangthaihocsinh_id: data.dm_trangthaihocsinh_id,
                        dm_trangthaihocsinh_name: data.dm_trangthaihocsinh_name,
                        name: data.dm_trangthaihocsinh_name,
                        so_luong: 0
                    })
                }
                let item = result.get(data.dm_trangthaihocsinh_id);
                if (item) item.so_luong += data.si_so
            }
        })
        return result;
    }, [trangThai])
    return {
        dataStructed,
        dmTrangThais,
        expandedIds,
        rawData: data,
        rawTrangThai: trangThai
    }
}

